import { Component, OnInit } from '@angular/core';
import { ContentfulService } from '../../core/contentful.service';
import { Entry } from 'contentful';
import { NavbarService } from '../../core/navbar.service';
import { SeoService } from '../../core/seo.service';
@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {
  blmMiscellaneous: Entry<any>[] = [];
  constructor(
    private contentfulService: ContentfulService,
    public nav: NavbarService,
    private seo: SeoService
  ) { }

  ngOnInit() {
    this.nav.show();
    this.seo.updateTags({
      title: 'Our Story & Mission',
      description: 'Discover the 300-year history of Lacombe, Louisiana. From ancient shell mounds and Choctaw trade to the historic 1912 wooden schoolhouse and local traditions.',
      url: '/about'
    });
    this.contentfulService.getItems()
    .then(blmMiscellaneous => this.blmMiscellaneous = blmMiscellaneous);
  }
}